<!-- Global Loader - Available throughout the entire application -->
<app-loader></app-loader>

<!-- header -->
<app-header></app-header>

<!-- main-container part -->
<div class="main-container">
  <!-- added navigation -->
  <app-landing-layout [containerTemplate]="container"> </app-landing-layout>
  <!-- added router-outlet -->
  <ng-template #container>
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    <app-toast
      [isToastVisible]="(toastService.isToastVisible$ | async) ?? false"
      [message]="(toastService.message$ | async) ?? '' | content"
      class="toast"
      [toastType]="(toastService.toastType$ | async)!"
      [ariaLabel]="(toastService.ariaLabel$ | async) ?? '' | content"
      (closed)="toastService.close()"
    />
    @if (!isIframe) {
    <router-outlet></router-outlet>
    }
  </ng-template>
</div>

<!-- confirmation dialog at root level -->
@if ((confirmationDialogService.isOpen$ | async) ?? false) {
<app-confirmation-dialog
  (confirm)="confirmationDialogService.confirm()"
  (dismissed)="confirmationDialogService.cancel()"
></app-confirmation-dialog>
}

<!-- footer -->
<app-footer></app-footer>

<!-- Global Banner Component - Appears at bottom of all pages -->
<app-banner></app-banner>
